module.exports = "import React from 'react';\nimport Paper from 'material-ui/Paper';\n\nconst style = {\n  height: 100,\n  width: 100,\n  margin: 20,\n  textAlign: 'center',\n  display: 'inline-block',\n};\n\nconst PaperExampleRounded = () => (\n  <div>\n    <Paper style={style} zDepth={1} rounded={false} />\n    <Paper style={style} zDepth={2} rounded={false} />\n    <Paper style={style} zDepth={3} rounded={false} />\n    <Paper style={style} zDepth={4} rounded={false} />\n    <Paper style={style} zDepth={5} rounded={false} />\n  </div>\n);\n\nexport default PaperExampleRounded;\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./src/app/components/pages/components/Paper/ExampleRounded.js
 ** module id = 1023
 ** module chunks = 0
 **/